export const CUSTOMERS_SECTION_ROUTES = {
  customerList: '/customers',
  customerImport: '/customers/import',
  customerEmptyImport: '/customers/import/onboarding',
  customerNew: '/customers/new',
  customerEdit: '/customers/edit/:id',
  customerDetails: '/customers/:id',
};
